<template>
    <van-popup
        v-if="workOrderEvaluatePopupShow"
        :value="workOrderEvaluatePopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="public_container add_approval_wrap">
            <div class="returnNavBar">
                <ReturnNavBar
                    title="返回"
                    :isCustomReturnEvent="true"
                    :isTitleNormal="true"
                    :isAllFunctions="true"
                    @returnEvent="handleClickClose"
                ></ReturnNavBar>
            </div>
            <div class="work_order_add_container mobile_container custom_mobile_form" v-loading="loading">
                <van-form
                    label-width="9.5em"
                    input-align="right"
                    scroll-to-error
                    :show-error-message="false"
                    :rules="WorkOrderEvaluateFormRules"
                    ref="WorkOrderEvaluateForm"
                    class=""
                >
                    <van-field
                        :required="true"
                        v-model="WorkOrderEvaluateForm.processing_users_text"
                        name="processing_users"
                        label="评价人"
                        placeholder="请选择"
                        :rules="WorkOrderEvaluateFormRules.processing_users"
                        error-message-align="right"
                        is-link
                        readonly
                        @click="handleClickProcessingUidsFieldlink()"
                    >
                    </van-field>
                    <van-field
                        :required="true"
                        v-model="WorkOrderEvaluateForm.star"
                        :rules="WorkOrderEvaluateFormRules.star"
                        type="number"
                        name="star"
                        label="评价分数"
                        placeholder="请输入"
                        error-message-align="right"
                    >
                    </van-field>
                    <van-field
                        v-model="WorkOrderEvaluateForm.content"
                        name="content"
                        label="评价内容"
                        placeholder="请输入"
                        error-message-align="right"
                        type="textarea"
                        :rows="5"
                        maxlength="500"
                        input-align="left"
                        class="vertical_input_wrap"
                    >
                    </van-field>
                </van-form>
            </div>
            <div class="add_footer_wrap mobile_add_footer_wrap">
                <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm"
                    >确定</van-button
                >
            </div>
            <!-- 实施人员选择 -->
            <UserSelect
                :userSelectVisible.sync="userSelectVisible"
                :userSelectTitle="'选择人员'"
                :selectType="'multiple'"
                :allUserList="processingUserList"
                @selectUserData="handleSelectUserData"
                v-if="userSelectVisible"
            />
        </div>
    </van-popup>
</template>
<script>
import { workOrderEvaluateDetail, workOrderEvaluate } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import UserSelect from "./component/user_select.vue";
export default {
    name: "WorkOrderEvaluate",
    components: { ReturnNavBar, UserSelect },
    props: {
        workOrderEvaluatePopupShow: {
            type: Boolean,
            default: false,
        },
        workorder_id: "",
        workorder_num: {
            type: String,
            default: ""
        },
        processingUserSelectedList: {
            type: Array,
            default: () => [],
        }, // 现在已经分配的实施人员数据
    },
    data() {
        return {
            loading: false,
            WorkOrderEvaluateForm: {
                processing_users: "",
                processing_users_text: "",
                star: "",
                content: "",
            },
            WorkOrderEvaluateFormRules: {
                processing_users: [{ required: true, message: "请选择", trigger: ["change"] }],
                star: [{ required: true, message: "请输入", trigger: ["blur", "change"] }],
            },
            previousValue: null, // 用于缓存合法值

            processingUserList: [], // 可以选择的
            userSelectVisible: false,

            btnDisabled: false,
        };
    },
    created() {
        this.getWorkOrderEvaluateDetail();
    },
    methods: {
        handleClickClose() {
            this.$emit("update:workOrderEvaluatePopupShow", false);
        },
        // 获取已经选择的人员id
        getWorkOrderEvaluateDetail() {
            workOrderEvaluateDetail({ workorder_id: this.workorder_id }).then((res) => {
                if (res.code === 200) {
                    const ids = res.data || [];
                    const processingUserList = this.processingUserSelectedList.map((item) => {
                        return {
                            ...item,
                            disabled: ids.includes(item.id),
                        };
                    });
                    this.processingUserList = processingUserList;
                }
            });
        },
        handleClickProcessingUidsFieldlink() {
            this.userSelectVisible = true;
        },
        // 选择实施人员确认
        handleSelectUserData(data) {
            this.WorkOrderEvaluateForm.processing_users = data.map((item) => item.id);
            this.WorkOrderEvaluateForm.processing_users_text = data.map((item) => item.name).join();
        },
        handleClickConfirm() {
            this.$refs.WorkOrderEvaluateForm.validate().then(() => {
                const processing_users = this.processingUserList
                    .filter((item) => this.WorkOrderEvaluateForm.processing_users.includes(item.id))
                    .map((item) => ({ processing_uid: item.id, processing_name: item.name }));
                const params = {
                    workorder_id: this.workorder_id,
                    workorder_num: this.workorder_num,
                    processing_users,
                    star: this.WorkOrderEvaluateForm.star,
                    content: this.WorkOrderEvaluateForm.content,
                };
                this.btnDisabled = true;
                workOrderEvaluate(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.btnDisabled = false;
                                    this.$emit("update:workOrderEvaluatePopupShow", false);
                                    this.$emit("evaluateSuccess");
                                },
                            });
                        } else {
                            this.btnDisabled = false;
                        }
                    })
                    .catch(() => {
                        this.btnDisabled = false;
                    });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.mobile_container {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
}
</style>
